import { ButtonGroup, Footer, Heading } from '@/components/footers/SimpleCTAFooter/SimpleCTAFooter.styled';
import { Container } from '@/components/layout/Container';
import { getBrandColor, hexToRGBA } from '@/styles/color/utils';
import { FC, ReactNode, useMemo } from 'react';

interface SimpleCTAFooterProps {
  heading: string;
  ctas?: ReactNode;
  background?: string;
}

const SimpleCTAFooter: FC<SimpleCTAFooterProps> = (props) => {
  const color = useMemo(() => {
    if (props.background) {
      if (props.background === 'transparent') {
        return props.background;
      }

      const brandColor = getBrandColor(props.background, 'tint');

      if (brandColor) {
        return `linear-gradient(0deg, ${hexToRGBA(brandColor, 1)} 0%, ${hexToRGBA(brandColor, 0)} 100%)`;
      }

      if (props.background.startsWith('gradient')) {
        return "transparent";
      }
    }

    return undefined;
  }, [props.background]);

  return (
    <Footer $background={color}>
      <Container>
        <Heading id="footer-heading">{props.heading}</Heading>
        <ButtonGroup>{props.ctas}</ButtonGroup>
      </Container>
    </Footer>
  );
};

SimpleCTAFooter.defaultProps = {
  background: 'transparent',
};

export default SimpleCTAFooter;
